"use client";

import {
  EnvelopeSimple,
  Phone,
  WhatsappLogo,
  YoutubeLogo,
  CaretDown,
} from "@phosphor-icons/react";
import { LinkedinLogo } from "@phosphor-icons/react/dist/ssr";
import Image from "next/image";
import { useState, useRef } from "react";
import Link from "next/link";

const getCoursePath = (course) => {
  const id = course?.id || course?._id || course?.course_id || course?.slug;
  return id ? `/courses/${id}` : null;
};

const socialLinks = {
    whatsappUrl:
      "https://api.whatsapp.com/send/?phone=919220361603&text=Hey%20I%20am%20interested%20in%20one%20of%20your%20course",

      youtubeUrl: "https://www.youtube.com/@SOFAR-Analytics",
  };


const FooterMobile = ({ courses }) => {

  const footerData = [
    {
      title: "Courses",
      items: (courses || [])
        .map((course) => ({
          label: course?.title || "Untitled",
          href: getCoursePath(course),
        }))
        .filter((item) => item.href),
    },
    {
      title: "Upcoming Batches",
      items: (courses || [])
        .map((course) => ({
          label: course?.title || "Untitled",
          href: getCoursePath(course),
        }))
        .filter((item) => item.href),
    },
    {
      title: "Articles",
      items: [
        { label: "Blogs", href: "/blog" },
        { label: "Study Material", href: null },
      ],
    },
    {
      title: "About Us",
      items: [
        { label: "Reviews", href: null },
        { label: "Our Trainers", href: null },
      ],
    },
  ];
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <footer className="md:hidden bg-[#222222] text-white px-[16px] py-[72px]">
      <div className="flex flex-col gap-[32px]">
        <div className="flex justify-center items-center">
          <Image src="/sofar_logo.svg" alt="Logo" width={254} height={106} />
        </div>

        <div className="flex flex-col gap-[32px]">
          <div className="flex gap-[54px] text-white">
            <LinkedinLogo size={32} />
            <a
              href={socialLinks.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsappLogo size={32} />
            </a>
            <a
              href={socialLinks.youtubeUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <YoutubeLogo size={32} />
            </a>
          </div>

          <div className="text-sm flex flex-col gap-[16px]">
            <div className="flex items-center gap-[16px]">
              <EnvelopeSimple size={32} />
              <span>sofarindia.helpdesk@gmail.com</span>
            </div>
            <div className="flex items-center gap-[16px]">
              <Phone size={32} />
              <span>+91 92203 61603</span>
            </div>
          </div>
        </div>

        <div className="w-full">
          {footerData.map((section, index) => (
            <div key={index} className="border-b border-[#E4E4E4]">
              <button
                onClick={() => toggleSection(index)}
                className="w-full text-left flex justify-between items-center py-3"
              >
                <span className="font-semibold">{section.title}</span>
                <CaretDown
                  size={20}
                  className={`transition-transform duration-500 ease-in-out ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>

              <div
                ref={(el) => (contentRefs.current[index] = el)}
                className={`overflow-hidden transition-all duration-500 ease-in-out`}
                style={{
                  maxHeight:
                    openIndex === index
                      ? `${contentRefs.current[index]?.scrollHeight}px`
                      : "0px",
                }}
              >
                <ul className="pl-2 pb-2 text-sm space-y-2 pt-2">
                  {section.items.map((item, idx) => (
                    <li key={idx}>
                      {item?.href ? (
                        <Link href={item.href}>{item.label}</Link>
                      ) : (
                        <span className="text-gray-300">{item?.label}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="text-xs flex gap-[8px] justify-center border-b border-[#E4E4E4] pb-[16px] flex-wrap items-center">
          <Link href="/privacy-policy" className="hover:text-blue-400 transition-colors">
            Privacy Policy
          </Link>
          <p>|</p>
          <Link href="/terms-and-conditions" className="hover:text-blue-400 transition-colors">
            Terms and Conditions
          </Link>
          <p>|</p>
          <Link href="/terms-and-conditions" className="hover:text-blue-400 transition-colors">
            Refund and Cancellation Policy
          </Link>
        </div>
        <div>
          <p className="text-xs text-center">
            Copyright © 2025 All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterMobile;
